import * as React from "react";

const IconMenuOpen: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="currentColor"><path fill="currentColor" fillRule="evenodd" d="M1.39299982,-4.72955008e-14 L7.035,5.642 L12.6070002,0.0700017678 L14,1.46300159 L8.428,7.035 L13.9299982,12.5369984 L12.5369984,13.9299982 L7.035,8.428 L1.46300159,14 L0.0700017678,12.6070002 L5.642,7.035 L2.73114864e-14,1.39299982 L1.39299982,-4.72955008e-14 Z"/></svg>;
};

export default React.memo(IconMenuOpen);
